import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const NAVY_DARK = '#0f3460';

export default function UrlPreviewCard({ data }) {
  if (!data?.url) return null;

  return (
    <Box
      sx={{
        mt: 1.25,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.200',
        overflow: 'hidden',
        bgcolor: 'grey.50',
      }}
    >
      {data.imageUrl && (
        <Box
          component="img"
          src={data.imageUrl}
          alt={data.title || 'Page preview'}
          sx={{ width: '100%', maxHeight: 140, objectFit: 'cover', display: 'block' }}
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      )}
      <Box sx={{ p: 1.25 }}>
        <Typography
          component="a"
          href={data.url}
          target="_blank"
          rel="noreferrer"
          variant="caption"
          sx={{ color: NAVY_DARK, fontWeight: 700, textDecoration: 'none', wordBreak: 'break-all' }}
        >
          {data.url}
        </Typography>
        {data.title && (
          <Typography variant="subtitle2" sx={{ mt: 0.75, fontWeight: 700, color: 'grey.900' }}>
            {data.title}
          </Typography>
        )}
        {data.description && (
          <Typography variant="body2" sx={{ mt: 0.5, color: 'grey.700', fontSize: 13 }}>
            {data.description}
          </Typography>
        )}
        {data.previewText && (
          <Typography
            variant="body2"
            sx={{
              mt: 0.75,
              color: 'grey.600',
              fontSize: 12,
              lineHeight: 1.5,
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {data.previewText}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

UrlPreviewCard.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    previewText: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
};
